import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Loading from './widgets/Loading'
import { store } from '../store'
import { push } from 'react-router-redux'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import {
    PRODUCT_UPDATE_LOADED,
    PRODUCT_UPDATE_UNLOADED,
    PRODUCT_UPDATE,
    PRODUCT_DELETE,
    REDIRECT,
    PRODUCT_LOAD_USER_CATEGORIES
} from '../constants/actionTypes';

const Promise = global.Promise
const mapStateToProps = state => ({
    ...state.product,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: PRODUCT_UPDATE_LOADED, payload }),
    onSubmit: (payload) => {
        dispatch({ type: PRODUCT_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: PRODUCT_UPDATE_UNLOADED }),
    onDelete: (payload) =>
        dispatch({ type: PRODUCT_DELETE, payload }),
    onRedirect: () =>
        dispatch({ type: REDIRECT }),
    onLoadCategories: (payload) =>
        dispatch({ type: PRODUCT_LOAD_USER_CATEGORIES, payload }),
});

class ProductEdit extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
            price: '',
            currency: '',
            category: '',
            categories: []
        }
        this.onSelectCategory = this.onSelectCategory.bind(this)
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (name, price, currency, category) => ev => {
            ev.preventDefault();
            const payload = agent.Products.updateProduct(this.props.match.params.key, name, price, currency, category)
            this.props.onSubmit(payload);
        }
        this.delete = () => ev => {
            ev.preventDefault()
            const payload = agent.Products.deleteProduct(this.props.match.params.key)
            this.props.onDelete(payload)
        }
    }
    onSelectCategory(option) {
        this.setState({ category: option.value })
    }
    componentWillMount() {
        const payload = agent.Products.getDetail(this.props.match.params.key)
        this.props.onLoad(payload);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.updated === true || nextProps.removed === true) {
            store.dispatch(push('/products/user/' + nextProps.product.userkey))
            this.props.onRedirect()
        } else if (nextProps.product) {
            Object.assign(this.state, {
                name: nextProps.product.name,
                price: nextProps.product.price,
                currency: nextProps.product.currency,
                category: nextProps.product.category_name,
            })
            if (!nextProps.categories) {
                const payload = agent.Categories.getCategories(nextProps.product.userkey)
                this.props.onLoadCategories(payload);
            } else {
                let categories = []
                for (let i in nextProps.categories) {
                    let name = nextProps.categories[i].name
                    categories.push({ label: name, value: name })
                }
                this.setState({ categories: categories })
            }
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.product) {
            return (
                <Loading />
            )
        }
        const name = this.state.name;
        const price = this.state.price;
        const currency = this.state.currency
        const category = this.state.category
        const categories = this.state.categories
        return (
            <div class='pane'>
                <Link className="crumb" to={`/product/${this.props.product.key}/detail`}>&laquo; back to detail</Link>

                <h1>Update product</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(name, price, currency, category)}>
                    <fieldset className="form">
                        <strong>Name</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={this.updateState('name')} />
                        </fieldset>
                        <strong>Price</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Price"
                                value={price}
                                onChange={this.updateState('price')} />
                        </fieldset>
                        <strong>Currency</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Currency"
                                value={currency}
                                onChange={this.updateState('currency')} />
                        </fieldset>
                        <strong>Category</strong>
                        <fieldset className="form-group">
                            <div style={{ maxWidth: '300px' }}><Dropdown options={categories} onChange={this.onSelectCategory} value={category} /></div>
                        </fieldset>
                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Update
                            </button>
                            <button
                                type="button"
                                onClick={this.delete()}
                                disabled={this.props.inProgress}>
                                Delete
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductEdit);



// WEBPACK FOOTER //
// ./src/components/ProductEdit.js